export default class Loyalty {
	constructor() {
		this.init();
	}

	init() {
		this.catalogConf = window.globalConf(window.globalCatalogConf);
		this.loyaltyConf = window.globalConf(window.globalLoyaltyConf);
		this.accountConf = window.globalConf(window.globalAccountConf);

		if (this.loyaltyConf) {
			this.elements = {
				points: document.querySelectorAll('[data-lyt-points]'),
				catalogPoints: document.querySelector('.js-catalog-xp-balance'),
				transactionLoader: document.querySelector('[data-transaction-loader]'),
				transactionTable: document.querySelector('[data-transaction-table]'),
				transactionEmpty: document.querySelector('[data-transaction-empty]'),
				pagination: document.querySelector('#transactionPagination'),
				referralChainTable: document.querySelector('#mlm-refferals'),
				langSwitch: document.querySelector('[data-lang-switch]')
			};

			this.getBalance();
		}
	}

	getToken() {
		if (!this.loyaltyConf || !this.loyaltyConf.customer || !this.loyaltyConf.customer.token) return '';
		return `Bearer ${this.loyaltyConf.customer.token}`;
	}

	async getBalance() {
		if (!this.catalogConf || !this.catalogConf.bonuses || !this.catalogConf.bonuses.urlBalance || !this.loyaltyConf) return;

		this.setLoading();

		try {
			const response = await fetch(this.catalogConf.bonuses.urlBalance, {
				method: 'POST',
				headers: {
					'Authorization': this.getToken()
				},
				body: JSON.stringify({
					id: this.catalogConf.customer.id
				})
			});

			const data = await response.json();
			let balance = 0;

			if (data && data.code === 200) {
				if (typeof data.data.balance !== "undefined") {
					balance = parseFloat(data.data.balance);
					balance = balance.toFixed(2);
				}
			}

			if (this.elements) {
				this.elements.points.forEach(el => el.textContent = balance);
				if (this.elements.catalogPoints) {
					this.elements.catalogPoints.textContent = balance + 'XP';
				}
			}

			this.changeBuyProduct(balance);
		} catch (e) {
			if (this.elements) {
				this.elements.points.forEach(el => el.textContent = '-.--');
				if (this.elements.catalogPoints) {
					this.elements.catalogPoints.textContent = '-.-- XP';
				}
			}
			console.error('Error getting balance:', e);
		}
	}

	changeBuyProduct(balance) {
		// todo: after create cart and final update product-card
		const products = document.querySelectorAll('.product-card:not(.product-card__not-available):not(.catalog__products-wrapper .product-card)');
		const lang = (this.elements && this.elements.langSwitch) ? this.elements.langSwitch.getAttribute('data-lang-switch') : 'uk';
		products.forEach(product => {
			const bonusPriceEl = product.querySelector('[data-bonus-price]');
			if (!bonusPriceEl) return;
			
			const bonusPrice = parseFloat(bonusPriceEl.getAttribute('data-bonus-price'));
			const addToCartBtn = product.querySelector('[data-add-to-cart]');
			const infoEl = product.querySelector('.form-message-attention.ic--info__about .ic--info__about--desktop');

			if (bonusPrice <= balance) {
				if (addToCartBtn) {
					addToCartBtn.classList.remove('btn--disabled');
					addToCartBtn.removeAttribute('aria-disabled');
					addToCartBtn.removeAttribute('aria-describedby');
				}
				if (infoEl) {
					infoEl.innerHTML = lang === 'ru' ? 'Для покупки, XP достаточно' : 'Щоб купити цей товар - XP вистачає';
				}
			} else {
				if (addToCartBtn) {
					addToCartBtn.classList.add('btn--disabled');
					addToCartBtn.setAttribute('aria-disabled', 'true');
				}
				if (infoEl) {
					const infoId = `info-${product.dataset.productId || Math.random().toString(36).substr(2, 9)}`;
					infoEl.id = infoId;
					addToCartBtn.setAttribute('aria-describedby', infoId);
					infoEl.innerHTML = lang === 'ru' ? 'XP недостаточно для покупки товара' : 'Недостатньо XP для покупки товару';
				}
			}
		});
	}

	setLoading() {
		if (this.elements && this.elements.points.length && this.loyaltyConf.urlLoader) {
			this.elements.points.forEach(el => {
				el.innerHTML = `<img src="${this.loyaltyConf.urlLoader}" alt="Loading...">`;
			});
		}
	}
}